export default __webpack_public_path__ + "static/media/Word_128x128.67a2744d.webp";